import Cliente from "../interfaces/Cliente.interface";
import FechaTool from "../tools/Fecha.tool";

const getEstructura = (): Cliente => {

    const usuario: Cliente = {

        IdCliente: 0,

        // Cabecera
        lugarEntrevista: "",
        fechaEntrevista: FechaTool.obtenerFecha(),

        // Datos del cliente
        nombres: "",
        paterno: "",
        materno: "",
        fechaNacimiento: "",
        actividadProfecion: {
            IdActividad: 0,
            tipo: {
                IdActividadTipo: 0,
                value: "",
            },
            value: "",
        },

        genero: {
            IdGenero: 0,
            value: "",
            otro: ""
        },

        paisNacimiento: {
            IdPais: 1,
            value: "México",
            nacionalidad: "Mexicana"
        },

        paisRecidencia: {
            IdPais: 1,
            value: "México",
            nacionalidad: "Mexicana"
        },

        nacionalidad: {
            IdPais: 1,
            value: "Mexicana",
            nacionalidad: "Mexicana"
        },

        estadoNacimiento: {
            IdEstado: 0,
            value: "",
            clave: ""
        },

        estadoRecidencia: {
            IdEstado: 0,
            value: "",
            clave: ""
        },

        ciudadRecidencia: {
            IdCiudad: 0,
            estado: {
                IdEstado: 0,
                value: "",
                clave: ""
            },
            value: ""
        },

        municipioRecidencia: {
            IdCiudad: 0,
            estado: {
                IdEstado: 0,
                value: "",
                clave: ""
            },
            value: ""
        },

        colonia: {
            IdColonia: 0,
            value: "",
            CP: ""
        },

        CP: "",
        calleAvenida: "",
        numeroExterioir: "",
        numeroInterioir: "",
        numeroTelefono: "",
        numeroTelefonoExtencion: "",
        correo: "",
        CURP: "",
        RFC: "",
        identificacionAutoridadEmite: "",
        identificacionNombre: "",
        identificacionNumero: "",
        tieneCredencialParaVotar: 0,
        tieneExtrangeroPasaporte: 0,
        tieneOtraIdentificacion: 0,
        tieneOtraIdentificacionDescripcion: "",
        tieneCRUP: 0,
        tieneCedulaSAT: 0,
        tieneFIEL: 0,
        tieneReciboPagoServicio: 0,
        tieneReciboPagoServicioDescripcion: "",
        tieneContratoArrendamientoVigente: 0,
        tieneEstadoCuentaBancario: 0,
        tieneConstanciaInscripcionRFC: 0,

        actuaNombrePropio: 1,
        actuaNombrePropioDescripcion: "",
        alguienAporteRecursos: 1,
        alguienAporteRecursosDescripcion: "",

        tieneFamiliaPolitica: 0,
        familiaPoliticaNombreCompleto: "",
        familiaPoliticaParentesto: "",
        familiaPoliticaPuesto: "",
        familiaPoliticaNacionalExtranjero: 1,
        familiaPoliticaFechaInicioPeriodo: "",
        familiaPoliticaFechaFinalPeriodo: "",

        tieneSueldo: 0,
        tieneHonorarios: 0,
        tieneVentaNegocio: 0,
        tieneVentaInmueble: 0,
        tieneHerencia: 0,

        operaciones: {
            efectivo: {
                IdMonto: 0,
                IdNumero: 0,
                IdFrecuencia: 0
            },
            transferencia: {
                IdMonto: 0,
                IdNumero: 0,
                IdFrecuencia: 0
            }
        },

        esMonedaNacional: 0,
        esMonedaExtranjera: 0,
        esActivosVirtuales: 0,

        trabajo: {
            nombreEmpresa: "",
            giroActividadEmpresa: "",
            direccionEmpresa: "",
            telefonoEmpresa: "",
            puestoCargo: "",
            areaDepartamento: "",
            fechaIngreso: "",
            fechaSalida: "",
            antiguedad: "",
            trabajaLunes: 0,
            trabajaMartes: 0,
            trabajaMiercoles: 0,
            trabajaJueves: 0,
            trabajaViernes: 0,
            trabajaSabado: 0,
            trabajaDomingo: 0,
            horaEntrada: "",
            horaSalida: "",
            tiempoTrabajado: "",
        },
        relacionDeNegocios: "",
        latitud: "0",
        longitud: "0",
        direccionExtranjero: "",
    };

    return usuario;
};

// const cast = (data: any): Cliente | null => {

//     const usuario: Cliente = {

//         IdCliente: data.IdCliente ?? 0,

//         // Cabecera
//         lugarEntrevista: "",
//         fechaEntrevista: FechaTool.obtenerFecha(),

//         // Datos del cliente
//         nombre: "",
//         paterno: "",
//         materno: "",
//         fechaNacimiento: "",
//         actividadProfecion: {
//             IdActividad: 0,
//             tipo: {
//                 IdActividadTipo: 0,
//                 value: "",
//             },
//             value: "",
//         },

//         genero: {
//             IdGenero: 0,
//             value: "",
//             otro: ""
//         },

//         paisNacimiento: {
//             IdPais: 1,
//             value: "México",
//             nacionalidad: "Mexicana"
//         },

//         paisRecidencia: {
//             IdPais: 1,
//             value: "México",
//             nacionalidad: "Mexicana"
//         },

//         nacionalidad: {
//             IdPais: 1,
//             value: "Mexicana",
//             nacionalidad: "Mexicana"
//         },

//         estadoNacimiento: {
//             IdEstado: 0,
//             value: "",
//             clave: ""
//         },

//         estadoRecidencia: {
//             IdEstado: 0,
//             value: "",
//             clave: ""
//         },

//         ciudadRecidencia: {
//             IdCiudad: 0,
//             estado: {
//                 IdEstado: 0,
//                 value: "",
//                 clave: ""
//             },
//             value: ""
//         },

//         municipioRecidencia: {
//             IdCiudad: 0,
//             estado: {
//                 IdEstado: 0,
//                 value: "",
//                 clave: ""
//             },
//             value: ""
//         },

//         colonia: {
//             IdColonia: 0,
//             value: "",
//             CP: ""
//         },

//         CP: "",
//         calleAvenida: "",
//         numeroExterioir: "",
//         numeroInterioir: "",
//         numeroTelefono: "",
//         numeroTelefonoExtencion: "",
//         correo: "",
//         CURP: "",
//         RFC: "",
//         identificacionAutoridadEmite: "",
//         identificacionNombre: "",
//         identificacionNumero: "",
//         tieneCredencialParaVotar: 0,
//         tieneExtrangeroPasaporte: 0,
//         tieneOtraIdentificacion: 0,
//         tieneOtraIdentificacionDescripcion: "",
//         tieneCRUP: 0,
//         tieneCedulaSAT: 0,
//         tieneFIEL: 0,
//         tieneReciboPagoServicio: 0,
//         tieneReciboPagoServicioDescripcion: "",
//         tieneContratoArrendamientoVigente: 0,
//         tieneEstadoCuentaBancario: 0,
//         tieneConstanciaInscripcionRFC: 0,

//         actuaNombrePropio: 1,
//         actuaNombrePropioDescripcion: "",
//         alguienAporteRecursos: 1,
//         alguienAporteRecursosDescripcion: "",

//         tieneFamiliaPolitica: 0,
//         familiaPoliticaNombreCompleto: "",
//         familiaPoliticaParentesto: "",
//         familiaPoliticaPuesto: "",
//         familiaPoliticaNacionalExtranjero: 1,
//         familiaPoliticaFechaInicioPeriodo: "",
//         familiaPoliticaFechaFinalPeriodo: "",

//         tieneSueldo: 0,
//         tieneHonorarios: 0,
//         tieneVentaNegocio: 0,
//         tieneVentaInmueble: 0,
//         tieneHerencia: 0,

//         operaciones: {
//             efectivo: {
//                 IdMonto: 0,
//                 IdNumero: 0,
//                 IdFrecuencia: 0
//             },
//             transferencia: {
//                 IdMonto: 0,
//                 IdNumero: 0,
//                 IdFrecuencia: 0
//             }
//         },

//         esMonedaNacional: 0,
//         esMonedaExtranjera: 0,
//         esActivosVirtuales: 0,

//         trabajo: {
//             nombreEmpresa: "",
//             giroActividadEmpresa: "",
//             direccionEmpresa: "",
//             telefonoEmpresa: "",
//             puestoCargo: "",
//             areaDepartamento: "",
//             fechaIngreso: "",
//             fechaSalida: "",
//             antiguedad: "",
//             trabajaLunes: 0,
//             trabajaMartes: 0,
//             trabajaMiercoles: 0,
//             trabajaJueves: 0,
//             trabajaViernes: 0,
//             trabajaSabado: 0,
//             trabajaDomingo: 0,
//             horaEntrada: "",
//             horaSalida: "",
//             tiempoTrabajado: ""
//         }
//     };

//     return null
// }

const ClienteModel = {
    getEstructura,
};

export default ClienteModel;

